import Accounting from "views/Settings/Accounting";
import { useParams } from "react-router-dom";
import Customization from "./Customization";
import General from "./General";
import Import from "./Import";

export default function SettingsOutlet() {
  const { subMenu } = useParams();

  switch (subMenu) {
    case "general":
      return <General />;
    case "customization":
      return <Customization />;
    case "accounting":
      return <Accounting />;
    case "import":
      return <Import />;
    default:
      return <General />;
  }
}
